import React from 'react';
import { createStyles, Grid, makeStyles, MenuItem, TextField } from '@material-ui/core';
import { Filter } from '../DataGridFilterMenu';
import { ColumnInstance } from 'react-table';
import { useTranslation } from '@fluentsms/i18n';

export type DataGridTransactionTypeFilterPropTypes = {
  filter: Filter;
  onFilterChange: (filterValue: Filter) => void;
  columns: ColumnInstance[];
};

const useStyles = makeStyles(() =>
  createStyles({
    columnInputLabel: {
      textTransform: 'capitalize',
    },
  }),
);

export const DataGridTransactionTypeFilter = ({
  filter,
  onFilterChange,
}: DataGridTransactionTypeFilterPropTypes): JSX.Element => {
  const classes = useStyles();
  const columnOptions = [
    'Construction Loan Only',
    'Home Equity Line of Credit (HELOC)',
    'Purchase with Cash',
    'Purchase with Loan',
    'Purchase with Loan including Draw',
    'Refinance',
  ];

  const operator = filter.operator;
  const shouldShowEnumList = ['is', 'isNot'].includes(operator || '');

  const { t } = useTranslation('common');
  const handleValueChange = (
    e: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    onFilterChange({ ...filter, value: (e.target.value as string) || '' });
  };

  const handleOperatorChange = (
    e: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    onFilterChange({ ...filter, operator: (e.target.value as string) || '' });
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={6}>
        <TextField
          id="operator-field"
          value={filter.operator || ''}
          label={t('operator')}
          InputLabelProps={{
            className: classes.columnInputLabel,
          }}
          onChange={handleOperatorChange}
          data-testid="data-grid-enum-filter-operator-field"
          select
          fullWidth
        >
          <MenuItem key={`filter-operator-is`} value="is" data-testid="data-grid-string-filter-operator-option-is">
            is
          </MenuItem>
          <MenuItem
            key={`filter-operator-is-not`}
            value="isNot"
            data-testid="data-grid-string-filter-operator-option-is-not"
          >
            is NOT
          </MenuItem>
          <MenuItem
            key={`filter-operator-contains`}
            value="contains"
            data-testid="data-grid-string-filter-operator-option-contains"
          >
            contains
          </MenuItem>
          <MenuItem
            key={`filter-operator-starts-with`}
            value="startsWith"
            data-testid="data-grid-string-filter-operator-option-starts-with"
          >
            starts with
          </MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label={t('value')}
          value={filter.value || ''}
          InputLabelProps={{
            className: classes.columnInputLabel,
          }}
          onChange={handleValueChange}
          data-testid="data-grid-enum-filter-value-field"
          select={shouldShowEnumList}
          fullWidth
          disabled={!operator}
        >
          {shouldShowEnumList &&
            columnOptions.map((value, index) => (
              <MenuItem key={`filter-enum-option-${index}`} value={value} data-testid={`filter-enum-option-${index}`}>
                {value.split(/[_-]/).join(' ')}
              </MenuItem>
            ))}
        </TextField>
      </Grid>
    </Grid>
  );
};
export default DataGridTransactionTypeFilter;
